//import { google } from "google-charts/dist/googleCharts.js";

//import "google-charts/dist/googleCharts.js";

import { GoogleCharts } from "google-charts";

import { ViewRenderer, ChartOptions, IViewData } from "./ah.mb.ui.view-builders";

    export class ChartSeriesTypeConstants {
        static area = 0;
        static line = 1;
        static bar = 2;
        static combo = 3;
        static table = 4;
        static geo = 5;
    }

    /**
     * Nvd3 chart renderer
     */
    export class GoogleChartRenderer implements ViewRenderer {

        private forceViewTypeId = -1;

        forceViewType(viewTypeId: number) {
            this.forceViewTypeId = viewTypeId;
        }

        private chartOptions: ChartOptions;

        /**
         * Chart instance
         * Note: this is not very good because it introduces state, try not to use this
         */
        chartInstance: google.visualization.ChartWrapper;



        /**
         * Ctor
         */
        constructor(options?: ChartOptions) {
            this.chartOptions = options ||
            {
                showLegend: true,
                showTitle: false,
                showXAxisTitlesFunc: (title) => true,
                showYAxisTitlesFunc: (title) => true,
                backgroundColor: "#ecf0f5"
                };        }

        /**
         * Clears the chart
         * @param target
         */
        private clear = (target: JQuery): void => {

            //if (this.chartInstance)
            //this.chartInstance.clearChart();
            //while (target.children().length> 0 )
            //    target.children().remove("*");
        }

        /**
         * Before render
         * @param target
         * @param viewName
         */
        beforeRender = (target: JQuery, viewName: string): Promise<any> =>{

            //this.clear(target);

            // var svgId = viewName + "_svg";

            //var toolsBtn = '<button type="button" class="btn btn-primary btn-xs" data-toggle="button">Single toggle</button>';
           // var toolsBtn = '<button type="button" class="btn btn-link">Table</button>';
            //target.append(toolsBtn);

            //const selectedCheckBox = `<div class="checkbox view-selector-checkbox-div" class="viewSelecterCheckBoxDiv">
            //        <label><input type="checkbox" class="viewSelectorCheckBox" value="selected" data-viewid="${viewName}"> </input>
            //            <span>${viewName}</span>
            //            </label></div>`;

            ////'<div class="checkbox" style="margin-top:0">'
            ////    + '<label style="font-weight:bold; margin-left:10px">'
            ////    + '<input type="checkbox" class="viewSelectorCheckBox" value="selected" data-viewid="' + viewName + '">'
            ////    + viewName
            ////    + "</label>"
            ////    + "</div>";
              
            //target.append(selectedCheckBox);

            //return $.Deferred().resolve();

            // Show loader indication
            return this.showLoadingIndicator(target);


        }

        /**
         * Shows the loading indicator
         * @param target
         */
        private showLoadingIndicator = (target: JQuery): Promise<any> => {

            // Todo: Fix this
            //const loaderDiv = '<div id="loader" class="center-x-and-y">' +
            //    '<img alt="activity indicator"  src= "/Content/ajax-loader.gif" class="center-x-and-y">' +
            //    "</div>";
       
            //target.append(loaderDiv);

            //$("#loader").show();

            return Promise.resolve(); // $.Deferred().resolve();
        }

                                                                  
        /**
         * Hides loading indicator
         * @param target
         */
        private hideLoadingIndicator = (target: JQuery) :Promise<any> => {

            // Todo: Fix this
            //target.find("#loader").hide();
            return Promise.resolve();
//            return $.Deferred().resolve();

        }

        /**
         * After render
         * @param target
         * @param viewName
         */
        afterRender = (target: JQuery): Promise<any> => {

            return this.hideLoadingIndicator(target);

        }

        /**
         * Renders the view
         * @param target
         * @param data
         */
        render = (target: JQuery, data: IViewData) : Promise<any> => {

            // Before render
            return this.beforeRender(target, data.title)
                .then(() => {
                    // Draw
                    this.drawGraph(
                        target,
                        data,
                        this.chartOptions);
                })
            .then(() => this.afterRender(target));


        }

        /**
         * Refreshes the view
         */
        refresh() {
            this.chartInstance.draw();
        }
       
        /**
         * Draws the graph
         * @param target
         * @param reportResults
         */
        drawGraph(target: JQuery, reportResults: IViewData, options: ChartOptions): Promise<any> {

            this.chartOptions = options || this.chartOptions;

            this.chartOptions.backgroundColor = this.chartOptions.backgroundColor || "#ecf0f5";


            if (reportResults.failText) {
                target.html(`<h4>Error: ${reportResults.failText}</h3>`);

               return Promise.resolve();
                //if (doneFunc)
                //    doneFunc();

//                return null;
            }


            // Callback that creates and populates a data table,
            // instantiates the pie chart, passes in the data and
            // draws it.
            const drawChart = (): Promise<any> => {

                // Todo: Parameterize chart type properly
                var isPriceChart = reportResults.yAxisDataType === "Price"
                    || reportResults.yAxisDataType === "ReferencePrice" ||
                    reportResults.yAxisDataType === "Levelized Marginal Cost";

                var isMultiSeries = (reportResults.chartOptions.seriesType === ChartSeriesTypeConstants.combo);


                var chartType: string;

                // Check for view type override
                if (this.forceViewTypeId !== -1)
                    reportResults.chartOptions.seriesType = this.forceViewTypeId;

                switch (reportResults.chartOptions.seriesType) {
                case ChartSeriesTypeConstants.combo:
                    chartType = "ComboChart";
                    break;
                case ChartSeriesTypeConstants.line:
                    chartType = "LineChart";
                    break;
                case ChartSeriesTypeConstants.bar:
                    chartType = "BarChart";
                    break;
                case ChartSeriesTypeConstants.area:
                    chartType = "AreaChart";
                    break;
                case ChartSeriesTypeConstants.table:
                    chartType = "Table";
                     break;
                case ChartSeriesTypeConstants.geo:
                    chartType = "GeoChart";
                    break;
                default:
                    chartType = "LineChart";
                    break;
                }

                // Testing: 
                var vAxisFormat = isPriceChart ? "currency" : "scientific";

                // Special case: supply curve prices are too small
                if (reportResults.title === "Supply Curve")
                    vAxisFormat = "scientific";

                //var finalData = reportResults.isRawData
                //    ? google.visualization.arrayToDataTable(reportResults.chartData)
                //    : reportResults.chartData;


                const hoursPerYear = 8760;
                const oneHour = 1 / hoursPerYear;
                if (reportResults.xAxisDataType === "Time") {
                    reportResults.chartData.rows.forEach(row => {

                        var year = Math.floor(row.c[0].v);
                        var theDate = new Date(year, 0, 1);

                        var fraction = row.c[0].v - year;

                        if (fraction > 0) {
                            const hours = (fraction / oneHour); 
                            theDate.setHours(hours);
                        }
                        row.c[0].v = theDate;


                    });
                }

               var testData = reportResults.isRawData ? reportResults.chartData : new google.visualization.DataTable(reportResults.chartData);

//                testData.addColumn({ type: 'string', role: 'tooltip' });

                // Only show years in tooltips
                var dateFormatter = new google.visualization.DateFormat({
                    pattern: "yyyy"
                });
                dateFormatter.format(testData, 0);

                var cssClassNames = {
                    'headerRow': "darkblue-font bold-font",
                    'tableRow': "",
                    'oddTableRow': "beige-background",
                    'selectedTableRow': "orange-background large-font",
                    'hoverTableRow': "",
                    'headerCell': "gold-border",
                    'tableCell': "",
                    'rowNumberCell': "underline-blue-font"
                };

                var showLegend = this.chartOptions.showLegend &&
                    (!reportResults.chartData.cols || reportResults.chartData.cols.length > 1);

                // Set chart options
                var options: any = {
                    title: this.chartOptions.showTitle ? reportResults.title : "",
                    chartArea: {
                        left: showLegend? 100 : 40,
                        top: 5,
                        width: showLegend ? "73%" : "80%",
                        height: showLegend ? "90%" : "85%"
                    },
                    curveType: "none",
                    strokeWidth: 0,
                    legend: {
                        position: showLegend ? "right" : "none",
                        textStyle: { fontSize: 12 }
                    },
                    focusTarget: "category",
                    backgroundColor: { fill: "transparent" },
                    isStacked: reportResults.chartOptions.isStacked, // For area charts
                    animation: { duration: 600, "startup": true, easing: "out" },
                    vAxis: {
                        title: showLegend ? reportResults.yAxisDataType: "",
                        format: vAxisFormat,
                        gridlines: { color: "none", count: showLegend? -1: 4 }, // If automatic in small mode there's not enough points on y-axis
                        textStyle: { fontSize: 12 },
                        titleTextStyle: { italic: false },
                        minValue:0
                    },
                    hAxis: {
                        title: showLegend? reportResults.xAxisDataType: "",
                        textStyle: { fontSize: 12 },
                        titleTextStyle: { italic: false },
                        gridlines: { color: "none" /*count: -1 */ }
                    },
                    lineWidth: reportResults.chartOptions.seriesType === ChartSeriesTypeConstants.area ? 0: 2,
                    explorer: {
                        maxZoomOut: 2,
                        maxZoomIn: 0.10,
                        keepInBounds: true
                    },
                    cssClassNames: cssClassNames,
                    allowHtml: true,

                    // Geo options
                    region: reportResults.geoChartSettings.regionCode, // "150",
                    resolution: reportResults.geoChartSettings.resolution, 
                    displayMode: "regions",
                    enableRegionInteractivity: true

                };

                // Hardcoded multiseries bs
                if (isMultiSeries) {

                    options.seriesType = "line";
                    options.series = [{ type: "line" }];
                    for (let i = 1; i < reportResults.chartData.cols.length; i++) {
                        options.series.push({ type: "area", lineWidth: 0 });
                    };

                }

                // For aggregate line charts set the Price line to be thicker so easier to see
                if (reportResults.title === "Aggregate Supply Stack") {

                    var supplyPriceLine = { lineWidth: 4, lineDashStyle: [2, 2] };

                    options.series = {
                        0: supplyPriceLine
                    }

                    if (reportResults.chartData.cols.length > 1) {
                        var hubPriceLine = { lineWidth: 3, lineDashStyle: [1, 1] };

                        options.series = {
                            0: supplyPriceLine,
                            1: hubPriceLine
                        };
                    }
                }


                if (reportResults.xAxisDataType === "Supply") {

                    // Disgusting SLC stuff

                    var seriesOptions = [];
                    for (let i = 0; i < reportResults.chartData.cols.length; i++) {
                        var colorOptions: any = { areaOpacity: 1 };
                        if //(reportResults.chartData.cols[i].label.indexOf("pMin") > 0) 
                        (i % 2 === 1)
                        {


                            colorOptions.color = this.chartOptions.backgroundColor;
                            colorOptions.visibleInLegend = false;
                        }


                        seriesOptions.push(colorOptions);

                    }

                    options.series = seriesOptions;

                }

                // For some reason view doesn't DataView doesn't work any more
                //var view = new google.visualization.DataView(testData);

                // Todo Resolve hiding index column
                //if (chartType === "Table" && reportResults.chartData.cols &&
                //    reportResults.chartData.cols.length === 2 && reportResults.chartData.cols[0].label === "Index") {
                //    view.hideColumns([0]);
                //}

                // Instantiate chart
                var wrapper = new google.visualization.ChartWrapper(
                {
                    chartType: chartType,
                    dataTable: testData,
                    options: options,
                    containerId: target.attr("id")
                });

                try {
                    wrapper.draw();
                }
                catch (err) {
                    console.log(err)
                }

                this.chartInstance = wrapper;

                return Promise.resolve(this.chartInstance);

            };

            this.loadGoogleLibraries(drawChart);


            return Promise.resolve();

            //if (doneFunc)
            //    doneFunc();


        }

        loadGoogleLibraries(callback: () => void) {
            // Load the Visualization API and the corechart package.
            GoogleCharts.load(callback,
                { mapsApiKey: 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY' }); //"current", { 'packages': [] });
            //            google.charts.load("current", { 'packages': ["corechart"] });

            // Set a callback to run when the Google Visualization API is loaded.
//            GoogleCharts.charts.setOnLoadCallback(callback);

        }
    }



// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.googleChartRenderer.ts